import isNull from 'lodash/isNull';
import {useEffect, useState} from 'react';
import {getUrlParams} from '../common/getUrlParams';
import {requestContext} from '../common/requestContext';
import {useHasMounted} from '../common/shared/hooks/useHasMounted';
import {IS_CLIENT_SIDE} from '../common/shared/utils/constants';
import {AppLinkDialog} from '../design-system/organisms/AppLinkDialog/AppLinkDialog';
import {PAGE_LINK_PAGE_URL_PARAM_KEY} from '../domain/bridge/applink/constant';

export function useAppLinkDialog() {
  const [isOpen, setIsOpen] = useState(false);
  const {params} = IS_CLIENT_SIDE
    ? getUrlParams(window.location.search)
    : {params: null};
  const hasMounted = useHasMounted();

  useEffect(() => {
    if (hasMounted) {
      return;
    }
    const shouldShowAppLinkDialog =
      !isNull(params) &&
      document.referrer.includes('bridge/applink') &&
      requestContext.requestInfo.display.isMobile &&
      !requestContext.requestInfo.display.isWebView &&
      Object.prototype.hasOwnProperty.call(
        params,
        PAGE_LINK_PAGE_URL_PARAM_KEY
      );
    setIsOpen(shouldShowAppLinkDialog);
  }, [hasMounted, params]);

  return {
    AppLinkDialog,
    isOpen,
    setIsOpen,
    closeDialog: () => setIsOpen(false),
    linkUrl: params && params[PAGE_LINK_PAGE_URL_PARAM_KEY],
  };
}
